import kohlerCorporateConfig from '../kohlerCorporateConfig';

import { jsonToQueryString } from "../utilities/jsonToQueryString";

/*
 * Service to provide search results model
 */

//  const fakeApi = () => {
//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve({
//                 json: () => new Promise((resolve) => {

//                     resolve({
//                         "FilterGroupItems": {
//                             "Category": [
//                                 {
//                                     "Value": "",
//                                     "Text": "All",
//                                     "IsSelected": false
//                                 },
//                                 {
//                                     "Value": "News",
//                                     "Text": "News",
//                                     "IsSelected": true
//                                 },
//                                 {
//                                     "Value": "Story",
//                                     "Text": "Story",
//                                     "IsSelected": false
//                                 },
//                                 {
//                                     "Value": "Videos",
//                                     "Text": "Videos",
//                                     "IsSelected": false
//                                 }
//                             ]
//                         },
//                         "Results": [
//                             {
//                                 "Name": "This is a news story",
//                                 "Url": "https://www.kohler.com/link-to-stuff/",
//                                 "UrlType": "Link",
//                                 "Category": "News",
//                                 "Summary": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quae exercitationem, odit optio ipsam perferendis nemo eum qui nobis, numquam impedit eligendi reiciendis, accusamus eaque facilis explicabo soluta sunt placeat earum?",
//                                 "PreviewImage": "https://www.scene7.com/randomimage.png",
//                             },
//                             {
//                                 "Name": "This is a video",
//                                 "Url": "https://www.kohler.com/link-to-stuff/",
//                                 "UrlType": "ModalVideo",
//                                 "Category": "Video",
//                                 "Summary": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quae exercitationem, odit optio ipsam perferendis nemo eum qui nobis, numquam impedit eligendi reiciendis, accusamus eaque facilis explicabo soluta sunt placeat earum?",
//                                 "PreviewImage": "https://www.scene7.com/randomimage.png",
//                             },
//                             {
//                                 "Name": "This is a file",
//                                 "Url": "https://www.kohler.com/link-to-download/",
//                                 "UrlType": "Download",
//                                 "Category": "Article",
//                                 "Summary": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quae exercitationem, odit optio ipsam perferendis nemo eum qui nobis, numquam impedit eligendi reiciendis, accusamus eaque facilis explicabo soluta sunt placeat earum?",
//                                 "PreviewImage": "https://www.scene7.com/randomimage.png",
//                             },
//                             {
//                                 "Name": "This is a news story",
//                                 "Url": "https://www.kohler.com/link-to-stuff/",
//                                 "UrlType": "Link",
//                                 "Category": "News",
//                                 "Summary": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quae exercitationem, odit optio ipsam perferendis nemo eum qui nobis, numquam impedit eligendi reiciendis, accusamus eaque facilis explicabo soluta sunt placeat earum?",
//                                 "PreviewImage": "https://www.scene7.com/randomimage.png",
//                             },
//                             {
//                                 "Name": "This is a video",
//                                 "Url": "https://www.kohler.com/link-to-stuff/",
//                                 "UrlType": "ModalVideo",
//                                 "Category": "Video",
//                                 "Summary": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quae exercitationem, odit optio ipsam perferendis nemo eum qui nobis, numquam impedit eligendi reiciendis, accusamus eaque facilis explicabo soluta sunt placeat earum?",
//                                 "PreviewImage": "https://www.scene7.com/randomimage.png",
//                             },
//                             {
//                                 "Name": "This is a file",
//                                 "Url": "https://www.kohler.com/link-to-download/",
//                                 "UrlType": "Download",
//                                 "Category": "Article",
//                                 "Summary": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quae exercitationem, odit optio ipsam perferendis nemo eum qui nobis, numquam impedit eligendi reiciendis, accusamus eaque facilis explicabo soluta sunt placeat earum?",
//                                 "PreviewImage": "https://www.scene7.com/randomimage.png",
//                             }
//                         ],
//                         "TotalItems": 6
//                     });
//                 })
//             })
//         }, 500);
//     });
// };

// class SearchService {
//     getResults(query) {
//         return fakeApi()
//             .then(res => res.json())
//             .then(json => json);
//     }
// }

class SearchService {

    /**
     * @param {{s: string, filter: string}} queryObject
     * @param {Number} offset
     * @param {Number} itemsPerPage
     */
    async getResults(queryObject, offset, itemsPerPage) {
        /* Expected format for body */
        const body = {
            query: queryObject.q || '',
            filterValues: {
                Category: queryObject.filter
            },
            offset: offset,
            itemsPerPage: itemsPerPage
        };

        return fetch(kohlerCorporateConfig.globalSearchEndpointUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {'Content-type': 'application/json; charset=utf-8'},
            body: JSON.stringify(body),
            referrer: "no-referrer",
        })
        .then(response => response.json())
        .catch(error => {console.log(error);return []});
    }

}
export default new SearchService();
